export enum UserPhoneNumbersQueryKey {
  Me = '/user-phone-numbers/me',
  ById = '/user-phone-numbers/:id',
  Lookup = '/user-phone-numbers/lookup',
}
